import { render, staticRenderFns } from "./offerDealsInquiryDetails.vue?vue&type=template&id=82215a3c&"
import script from "./offerDealsInquiryDetails.vue?vue&type=script&lang=js&"
export * from "./offerDealsInquiryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports